import {Box} from "@mui/material";

const ReadSidebarTabLabel: React.FC<{ count: number; label: string }> = ({
                                                                             count,
                                                                             label
                                                                         }) => {
    return (
        <Box sx={{textAlign: "center", textTransform: "none", pt: 1}}>
            <Box component="span"
                 sx={{fontWeight: 600, fontSize: "1rem", lineHeight: 1.2}}>
                {count}
            </Box>
            <Box sx={{fontSize: "0.7rem", lineHeight: 1.2}}>{label}</Box>
        </Box>
    );
};

export default ReadSidebarTabLabel;
